export interface TenantModel {
  id?: number;
  tenantId?: string;
  fullName?: string;
}

export enum EScopesType {
  support_r = "support_r",
  support_w = "support_w",
  shipping_r = "shipping_r",
  shipping_w = "shipping_w",
  operator_r = "operator_r",
  operator_w = "operator_w",
  supportportalaccess_r = "supportportalaccess_r",
}
